import moment from 'moment';

import {
  WEEKDAY_NUMBERS, WEEKDAY_ABBREVIATIONS, WEEKDAY_NAMES,
  START_OF_DAY, END_OF_DAY, TIME_NOT_SELECTED,
} from '../../../../lib/constants/constants';

const { convertTimeTo12HoursFormat, store } = require('../../../../lib/bputils').default;

const spawnDropDownHours = () => {
  const dropDownHours = [];
  dropDownHours.push({ label: TIME_NOT_SELECTED, value: TIME_NOT_SELECTED });
  for (let i = 0; i < 24; i += 1) {
    dropDownHours.push({
      label: convertTimeTo12HoursFormat(`${i}:00`),
      value: `${String(i).padStart(2, '0')}:00`,
    });
    dropDownHours.push({
      label: convertTimeTo12HoursFormat(`${i}:30`),
      value: `${String(i).padStart(2, '0')}:30`,
    });
  }

  return dropDownHours;
};

const buildStationHours = (action, intervals = []) => {
  switch (action) {
    case 'STATION_OPEN':
      return openHoursStateBuilder(intervals);
    case 'OPEN_247':
      return Object.values(simpleStationHoursBuilder(true, false));
    case 'STATION_CLOSED':
      return Object.values(simpleStationHoursBuilder(false, true));
    case 'NOT_SET':
      return Object.values(simpleStationHoursBuilder());
    default:
      return undefined;
  }
};

const transformOpeningHours = (openingHours) => {
  if (openingHours.opening_hours) {
    if (openingHours.opening_hours === '24/7') {
      return { regularHours: buildStationHours('OPEN_247') };
    }
    if (Object.keys(openingHours.hours_by_day).length === 0) {
      return { regularHours: buildStationHours('STATION_CLOSED') };
    }
    return { regularHours: buildStationHours('STATION_OPEN', openingHours.hours_by_day) };
  }
  return { regularHours: buildStationHours('NOT_SET') };
};

const simpleStationHoursBuilder = (open24x7 = false, closedStation = false) => {
  const hours = {};
  for (let i = 0; i < WEEKDAY_NUMBERS.length; i += 1) {
    hours[WEEKDAY_NUMBERS[i]] = {
      dayNumber: WEEKDAY_NUMBERS[i],
      day: WEEKDAY_NAMES[i],
      open: '----',
      close: '----',
      openAllDay: open24x7,
      closed: closedStation,
    };
  }
  return hours;
};

const openHoursStateBuilder = (hoursByDay) => {
  const hoursByDayClone = _.cloneDeep(hoursByDay);
  // handle days station is closed
  const stationHours = simpleStationHoursBuilder(false, true);
  Object.keys(hoursByDayClone).forEach((dayNumber) => {
    const dayHours = hoursByDayClone[dayNumber];
    if (dayHours) {
      const { open, close } = dayHours;
      stationHours[dayNumber] = {
        dayNumber: WEEKDAY_NUMBERS[dayNumber - 1],
        day: WEEKDAY_NAMES[dayNumber - 1],
        open,
        close,
        openAllDay: dayHours.open === START_OF_DAY && dayHours.close === END_OF_DAY,
        closed: false,
      };
    }
  });

  // sort days, start on monday
  return daySorter(Object.values(stationHours));
};

const daySorter = (stationHours) => {
  const dSort = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };
  return (stationHours).sort((a, b) => dSort[a.day] - dSort[b.day]);
};

const generateHoursString = (hours) => {
  const openingHours = [];
  // We need to keep `open` and `closed` rules at the begining of the string.
  const openingHoursForOpenAndClosed = [];

  for (let i = 0; i < WEEKDAY_NUMBERS.length; i += 1) {
    const dayHours = hours.find(h => h.dayNumber === WEEKDAY_NUMBERS[i]);

    if (dayHours.openAllDay) {
      openingHoursForOpenAndClosed.push(`${WEEKDAY_ABBREVIATIONS[i]} open;`);
    } else if (dayHours.closed) {
      openingHoursForOpenAndClosed.push(`${WEEKDAY_ABBREVIATIONS[i]} closed;`);
    } else if (dayHours.open !== TIME_NOT_SELECTED && dayHours.close !== TIME_NOT_SELECTED) {
      openingHours.push(`${WEEKDAY_ABBREVIATIONS[i]} ${dayHours.open}-${dayHours.close}`);
    } else {
      return {
        error: true,
        str: `Please provide station hours for ${dayHours.day}.`,
      };
    }
  }
  return {
    error: false,
    str: openingHoursForOpenAndClosed.join('') + openingHours.join(','),
  };
};

const hideTimeIf24HourOpen = (operationHours) => {
  if (operationHours.openAllDay) {
    operationHours.open = TIME_NOT_SELECTED;
    operationHours.close = TIME_NOT_SELECTED;
  }
  return { ...operationHours };
};

const getHoursForDisplay = (currentHours) => {
  // This is required to successfully compare the objects
  const regularHours = currentHours.map(h => hideTimeIf24HourOpen(h));
  const cachedHours = store.get('saved_hours');

  // Expire cache after 15 minute even if hours are not updated.
  if (cachedHours === undefined || moment().utc().diff(cachedHours.savedAt, 'minutes') > 15 || _.isEqual(regularHours, cachedHours.regularHours)) {
    store.remove('saved_hours');
    return { regularHours: currentHours, serverReturnedDifferentHours: false };
  }
  return { regularHours: cachedHours.regularHours, serverReturnedDifferentHours: true };
};

export { spawnDropDownHours, generateHoursString, buildStationHours, transformOpeningHours, hideTimeIf24HourOpen, getHoursForDisplay };
